import { object, string, number } from 'yup'

const maxPercentage = 99.999

export interface IStrikePriceOverrideSchema {
  overridePercentage: number
  reason: string
  dateRange: {
    startAt: string
    endAt: string
  }
}

export const StrikePriceOverrideSchema = object<IStrikePriceOverrideSchema>({
  overridePercentage: number()
    .typeError('Must enter a number')
    .required('Must enter a percentage')
    .max(maxPercentage),
  reason: string().required('Must enter a reason'),
  dateRange: object().shape({
    startAt: string().required('Must specify a date range'),
    endAt: string().required('Must specify a date range'),
  }),
})
